import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const LoomIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M20 8.8879H14.1517L19.2166 5.96368L18.1043 4.0366L13.0394 6.96081L15.963 1.89631L14.0359 0.78337L11.1123 5.84786V0H8.88765V5.84842L5.96297 0.78337L4.03649 1.89576L6.96061 6.96025L1.8957 4.0366L0.783349 5.96312L5.84826 8.88734H0V11.1121H5.8477L0.783349 14.0363L1.8957 15.9634L6.96005 13.0398L4.03593 18.1042L5.96297 19.2166L8.88709 14.1516V20H11.1118V14.1521L14.0354 19.2166L15.9624 18.1042L13.0383 13.0392L18.1032 15.9634L19.2156 14.0363L14.1512 11.1126H19.9988V8.8879H20ZM10 13.0257C8.32253 13.0257 6.96285 11.6661 6.96285 9.98853C6.96285 8.31101 8.32253 6.9513 10 6.9513C11.6775 6.9513 13.0371 8.31101 13.0371 9.98853C13.0371 11.6661 11.6775 13.0257 10 13.0257Z"
      fill="#625DF5"
    />
  </SvgIcon>
);
